<template>
    <div class="text-center relative">
        <!-- Hero -->
        <div class="relative flex items-center block h-screen bg-gray-100">
            <div class="container mx-auto z-20 pt-20 text-center md:text-left px-4 relative">
                <h1 class="text-2xl md:text-4xl font-bold tracking-tight">Trabalhamos cada dia para encontrar<br>a melhor solução para os nossos candidatos</h1>
                
                <p class="mt-3 text-lg md:text-2xl">Somos uma empresa de trabalho temporário com capacidade de resposta rápida<br>e orientada para a satisfação dos nossos Clientes e Parceiros</p>

                <div class="flex flex-col text-center space-y-2 mt-8 md:flex-row md:space-y-0 md:space-x-4">
                    <a :href="route('empresas')" class="py-4 lg:py-6 px-4 md:px-20 bg-primary-900 hover:bg-violet-500 hover:shadow-2xl rounded-full text-white font-bold uppercase text-sm md:text-2xl transition-all flex items-center group relative">Procuro Talento <icon name="arrow-right" class="absolute w-8 h-8 text-white right-10 opacity-0 transition-all group-hover:opacity-100 group-hover:right-8" /></a>

                    <a :href="route('ofertas')" class="py-4 lg:py-6 px-4 md:px-20 bg-primary-900 hover:bg-violet-500 hover:shadow-2xl rounded-full text-white font-bold uppercase text-sm md:text-2xl transition-all flex items-center group relative">Procuro Emprego <icon name="arrow-right" class="absolute w-8 h-8 text-white right-10 opacity-0 transition-all group-hover:right-8 group-hover:opacity-100" /></a>
                </div>
            </div>

            <video class="right-0 top-0 z-10 h-screen object-cover grayscale brand-shape absolute opacity-50" autoplay muted id="myVideo" playsinline>
                <source src="/videos/bg_hero_1.mp4" type="video/mp4" id="mp4Src">
                    O seu Browser não suporta video, está na altura de atualizar.
            </video>
        </div>

        <div class="h-screen flex items-center relative" id="stamp-section">
            <div class="container mx-auto px-4 relative z-20">
                <div class="flex flex-col lg:flex-row items-center lg:space-x-12 text-center relative">
                    <object data="/images/pessoalform_25_anos.svg" type="image/svg+xml" class="relative pt-40 w-2/3 lg:w-1/2 transition-all ease-in-out duration-1000 opacity-0" id="stamp-image"></object>

                   <!--  <img src="/images/pessoalform_25_anos.svg" alt="selo 25 anos PessoalForm" class="relative pt-40 w-2/3 lg:w-1/2 transition-all ease-in-out duration-1000 opacity-0" id="stamp-image" /> -->

                    <p class="flex-1 text-xl lg:text-2xl lg:text-left mt-4 lg:mt-0 slide-in-right relative">O nosso trabalho assenta em valores principais como o <strong>rigor, qualidade, credibilidade, ambição e competência</strong>.<br><br>Estamos cientes dos nossos deveres, por isso conduzimos a nossa relação com clientes e colaboradores com uma <strong>atitude ética e responsável</strong>.<br><br>
                        <a :href="route('quem-somos')" class="group text-xs text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Mais sobre nós <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></a></p>
                </div>
            </div>
        </div>

        <div class="stats bg-primary-900 relative"> 
            <div class="container mx-auto py-20 px-4 relative">
                <div class="flex flex-col space-y-10 sm:space-y-0 sm:flex-row sm:space-x-10 md:space-x-40 text-white justify-center items-center">

                    <div class="border-2 border-white rounded-full p-10 h-32 w-32 md:h-48 md:w-48 text-center flex items-center justify-center block">
                        <div>
                            <div class="nums colocacoes font-bold text-xl md:text-3xl block transition" :stats="colocacoes"></div>
                            <p class="block uppercase font-bold text-xs md:text-sm">Colocações</p>
                        </div>
                    </div>

                    <div class="border-2 border-white rounded-full p-10 h-32 w-32 md:h-48 md:w-48 text-center flex items-center justify-center block">
                        <div>
                            <div class="nums parceiros font-bold text-xl md:text-3xl block transition" :stats="parceiros"></div>
                            <p class="block uppercase font-bold text-xs md:text-sm">Parceiros</p>
                        </div>
                    </div>

                    <div class="border-2 border-white rounded-full p-10 h-32 w-32 md:h-48 md:w-48 text-center flex items-center justify-center block">
                        <div>
                            <div class="nums oportunidades font-bold text-xl md:text-3xl block transition" :stats="oportunidades"></div>
                            <p class="block uppercase font-bold text-xs md:text-sm">Oportunidades</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- ultimas -->
        <div class="container mx-auto px-4 py-20" v-if="posts.length">
            <h3 class="py-8 uppercase font-bold text-primary-900">últimas do Blog</h3>
            <div class="grid lg:grid-cols-3 gap-6">
                <a v-for="post in posts" :href="route('show.post', post.id)" class="flex-1 hover:scale-105 group transition-all rounded-lg">
                    <img :src="'/storage/posts/' + post.image" :alt="post.title" class="object-cover h-48 w-full rounded-tl-lg rounded-tr-lg grayscale group-hover:grayscale-0" />
                    <span class="w-full block text-left relative py-8">
                        <a :href="route('show.post', post.id)"><h1 class="leading-6 text-xl font-bold text-primary-900">{{ post.title }}</h1></a>
                        <span class="text-left mt-2 leading-none text-gray-400 text-xs">
                           {{ dateFormated(post.created_at) }}
                        </span>
                        <p class="leading-relaxed my-4" v-html="post.excerto"></p>
                        <a class="group text-xs text-violet-500 font-bold flex items-center uppercase py-1 px-6 rounded-full border border-violet-500 inline-flex relative" :href="route('show.post', post.id)">Mais
                            <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-1" />
                        </a>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .btn2 span:first-child{
      transform: translateX(-101%);
      transition: transform .1s ease-in
    }
    .btn2:hover span{
      transform: translateX(0)
    }
   .button {
        pointer-events: auto;
        cursor: pointer;
        background: #e7e7e7;
        border: none;
        padding: 1.5rem 3rem;
        margin: 0;
        font-family: inherit;
        font-size: inherit;
        position: relative;
        display: inline-block;
    }

.button::before,
.button::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.button--janus {
    font-weight: 900;
    width: 175px;
    height: 120px;
    color: white;
    background: none;
}

.button--janus::before {
    content: '';
    background: #3A3761;
    -webkit-clip-path: path("M154.5,88.5 C131,113.5 62.5,110 30,89.5 C-2.5,69 -3.5,42 4.5,25.5 C12.5,9 33.5,-6 85,3.5 C136.5,13 178,63.5 154.5,88.5 Z");
    clip-path: path("M154.5,88.5 C131,113.5 62.5,110 30,89.5 C-2.5,69 -3.5,42 4.5,25.5 C12.5,9 33.5,-6 85,3.5 C136.5,13 178,63.5 154.5,88.5 Z");
    transition: clip-path 0.5s cubic-bezier(0.585, 2.5, 0.645, 0.55), -webkit-clip-path 0.5s cubic-bezier(0.585, 2.5, 0.645, 0.55), background 0.5s ease;
}

.button--janus:hover::before {
    background: #8983E6;
    -webkit-clip-path: path("M143,77 C117,96 74,100.5 45.5,91.5 C17,82.5 -10.5,57 5.5,31.5 C21.5,6 79,-5.5 130.5,4 C182,13.5 169,58 143,77 Z");
    clip-path: path("M143,77 C117,96 74,100.5 45.5,91.5 C17,82.5 -10.5,57 5.5,31.5 C21.5,6 79,-5.5 130.5,4 C182,13.5 169,58 143,77 Z");
}

.button--janus::after {
    content: '';
    height: 86%;
    width: 97%;
    top: 5%;
    border-radius: 58% 42% 55% 45% / 56% 45% 55% 44%;
    border: 1px solid #8983E6;
    transform: rotate(-20deg);
    z-index: -1;
    transition: transform 0.5s cubic-bezier(0.585, 2.5, 0.645, 0.55);
}

.button--janus:hover::after {
    transform: translate3d(0,-5px,0);
}

.button--janus span {
    display: block;
    transition: transform 0.3s ease;
    mix-blend-mode: screen;
}

.button--janus:hover span {
    transform: translate3d(0,-10px,0);
}
/*.stats:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(https://www.toptal.com/designers/subtlepatterns/uploads/denim.png) repeat;
}*/
</style>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon'
    import Editor from '@tinymce/tinymce-vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            Icon,
            Editor
        },
        layout: FrontLayout,
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            posts: Array,
            page: Object
        },
        data(){
            return {
                colocacoes: 42570,
                parceiros: 206,
                oportunidades: 13429
            }
        },
        mounted() {
            var count = 1;
            var player = document.getElementById('myVideo');
            var vidSrc = document.getElementById('mp4Src');

            player.onended = function() {
                count++;
                vidSrc.setAttribute('src', "/videos/bg_hero_"+count+".mp4");
                player.load();
                player.play();
                if(count == 2) {
                    count = 0
                }
            };
            
        },
        created(){
            const root = this
            window.addEventListener("scroll", function() {
                
                // animate stats
                const e = document.querySelector('.stats') 
                // root.isInViewport(e) ? root.counter() : root.reset()
                root.isInViewport(e) ? root.counter() : null

                // animate selo 25 years
                const stampSection = document.getElementById('stamp-section')
                const stampImg = document.getElementById('stamp-image') 
                root.isInViewport(stampSection) ? stampImg.classList.add('pt-0', 'opacity-100') : null
            }, {
                passive: true
            })
        },
        methods: {
            BasicHover() {
              return (
                '<div className="transform h-64 bg-blue-400 w-80 transition duration-500 hover:scale-125 hover:bg-blue-600 flex justify-center items-center"><p className="text-lg">Hover over me! </p></div>'
              );
            },
            isInViewport(el) {
                const rect = el.getBoundingClientRect();
                return (
                    rect.top + 200 >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom - 150 <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            reset(){
                const counters = document.querySelectorAll('.nums')
              
                counters.forEach( counter => {
                    const value = +counter.getAttribute('stats');
                    counter.innerText = 0
                }); 
            },
            dateFormated(jobDate) {
                let date = new Date(jobDate)
                return date.toLocaleDateString()
            },
            counter() {
                const counters = document.querySelectorAll('.nums')
                const speed = 10000
            
                counters.forEach( counter => {
                    const animate = () => {
                        let value = +counter.getAttribute('stats');
                        const data = +counter.innerText;
                        const time = value / speed;

                        if(data < value) {
                            counter.innerText = Math.ceil(data + time);
                            setTimeout(animate, 1);
                        }else{
                            counter.innerText = value;
                        }
                    }

                    animate();
                    
                });          

                return
            }
        }
    })
</script>
